import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { TemplateProjectInfo } from '../../../../modules/projects/details/annotationTools/components/TemplateProjectInfo';
import { ProjectStatus } from '../../projects/projects.model';
import { PublishedProjectInfo } from '../components/PublishedProjectInfo';
import { IProjectDetailsBl } from '../projectDetails.bl';

export const PublishedProjectInfoContainer = observer((): ReactElement => {
  const projectDetailsBl = useInjection(IProjectDetailsBl.$);
  const showPublishedAlert = projectDetailsBl.store.status === ProjectStatus.Published;
  const showTemplateProjectAlert = !!projectDetailsBl.store.modelVariant && !showPublishedAlert;

  return (
    <>
      <PublishedProjectInfo showPublishedAlert={showPublishedAlert} />
      <TemplateProjectInfo showTemplateProjectAlert={showTemplateProjectAlert} />
    </>
  );
});
